module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-4-1943fd2e41702eba602d0a5660af834a.svg";